export default __webpack_public_path__ + "static/media/header_cover.fd9c61c5.png";